import { forwardRef } from 'react';
import { FONT_AWESOME_ICONS } from './constants';
import { StyledIcon, type IconProps } from './StyledIcon';
import type { GetRef } from 'antd';
import type { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type IconRef = GetRef<typeof FontAwesomeIcon>;

export const Icon = forwardRef<IconRef, IconProps>(({ iconString, ...rest }, ref) => {
  return <StyledIcon ref={ref} icon={FONT_AWESOME_ICONS[iconString]} {...rest} />;
});
